import {
  QueryInfo,
  prepareDataForApolloCache,
} from '../prepareDataForApolloCache';
import {
  MutationClaimOrganizationArgs,
  ClaimableOrganizationsQueryVariables,
} from 'packages/graphql/generated';
import { token } from '@trello/session-cookie';

export async function enterpriseClaimableOrganizationsResolver(
  enterprise: {
    id: string;
  },
  args: ClaimableOrganizationsQueryVariables,
  context: object,
  info: QueryInfo,
) {
  let model = null;
  const { limit, cursor } = args;
  const queryParams = `limit=${limit || 20}&cursor=${encodeURIComponent(
    cursor || '',
  )}`;

  const apiUrl = `/1/enterprises/${enterprise.id}/claimableOrganizations?${queryParams}`;

  try {
    const response = await fetch(apiUrl, {
      credentials: 'include',
    });

    if (response.ok) {
      const {
        organizations,
        claimableCount,
        cursor: nextCursor,
      } = await response.json();

      model = {
        organizations,
        count: claimableCount,
        cursor: nextCursor,
      };
    } else {
      throw new Error(
        `An error occurred while resolving a GraphQL query. (status: ${response.status}, statusText: ${response.statusText})`,
      );
    }

    return model ? prepareDataForApolloCache(model, info, 'Enterprise') : model;
  } catch (err) {
    console.error(err);
    return model;
  }
}

export const transferrableDataForOrganizationResolver = async (
  enterprise: {
    id: string;
  },
  args: { idOrganization: string },
  context: object,
  info: QueryInfo,
) => {
  const apiUrl = `/1/enterprises/${enterprise.id}/transferrable/organization/${args.idOrganization}`;

  const response = await fetch(apiUrl, {
    credentials: 'include',
  });

  if (!response.ok) {
    const error = await response.text();
    console.error(error);
    throw new Error(error);
  }

  const model = await response.json();

  // The API should probably not be sending back status 200 for this, but alas
  if ('message' in model) {
    console.error(model);
    throw new Error(model.message);
  }

  return model ? prepareDataForApolloCache(model, info, 'Enterprise') : model;
};

export const claimOrganization = async (
  obj: object,
  { idEnterprise, idOrganization }: MutationClaimOrganizationArgs,
  context: object,
  info: QueryInfo,
) => {
  const response = await fetch(`/1/enterprises/${idEnterprise}/organizations`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      idOrganization,
      token,
    }),
  });

  if (!response.ok) {
    const error = await response.text();
    console.error(error);
    throw new Error(error);
  }

  const model = await response.json();

  return prepareDataForApolloCache(model, info);
};
